import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { ConceptFamilyModel } from "./conceptfamily.model";
import { ConceptFamilyService } from "./conceptfamily.service";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConceptFamilyDialogDeleteComponent } from './conceptfamily-dialog-delete.component';
import { ConceptFamilyConst } from '../const';
import { DummyComponent } from '../../../shared/dummy.component';
import { ConceptFamilyComponent } from './conceptfamily.component';
import { Utils } from '../../../shared/utils';
import { consts } from '../../../consts';

@Component({
    selector: 'convfact-conceptfamily-list',
    templateUrl: './conceptfamily-list.component.html',
    styleUrls: ['./conceptfamily.component.css'],
    standalone: false
})

export class ConceptFamilyListComponent implements OnInit {

  constructor(private router: Router,
    private conceptFamilyService: ConceptFamilyService,
    public dialog: MatDialog,
    private dummy: DummyComponent,
    protected snackBar: MatSnackBar,
  ) { }

  dataSource: ConceptFamilyModel[] = [];
  empty = false;
  ready = false;

  searchText: string;
  headerTable: any[] = ConceptFamilyConst.headerTable;

  public create(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    uid = null;
    this.dialog.open(ConceptFamilyComponent, {
      data: { uid: uid }
    });
  }

  public edit(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.dialog.open(ConceptFamilyComponent, {
      data: { uid: uid }
    });
  }

  public delete(uid: string) {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.dialog.open(ConceptFamilyDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url);
      }
      );
  }

  public ngOnInit() {
    this.conceptFamilyService.getList().then(
      data => {
        this.dataSource = data;
        if (this.dataSource.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.ready = true;
      });
  }

}
